module.exports = __webpack_public_path__ + "img/first_rect.2491b072.svg";